@if (!showEntityMaps) {
  <div class="grid-x">
    <div class="cell small-12 red">
      Data Context -> Entity mappings must first be created via the Data Configuration tab before this side effect can be configured.
    </div>
  </div>
}
@if (showEntityMaps) {
  <div class="grid=x">
    <h5 class="bold">Action Mapping</h5>
    <div class="cell small-12">
      <label>
        Select mappings to add to the action:
      </label>
    </div>
  </div>
  @for (map of sideEffect.configuration.entities; track map) {
    <div class="grid-x">
      <div class="cell small-8 checkbox  small-font-size">
        <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" [attr.id]="map.mapId" [(ngModel)]="map.saveEntity" (ngModelChange)="mapSaveChanged(map.mapId)" />
        <label [attr.for]="map.mapId">
          <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
          {{ getMapName(map.mapId) }} - Creates Entity of type {{ getMapEntity(map.mapId) }}
        </label>
      </div>
      <div class="cell small-4 checkbox small-font-size">
        <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" [attr.id]="getPreviewId(map.mapId)" [(ngModel)]="map.isPreview" (ngModelChange)="previewOnlyChanged(map.mapId)" />
        <label [attr.for]="getPreviewId(map.mapId)">
          <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
          Preview Only
        </label>
      </div>
      @if (map.isPreview) {
        <div class="cell small-3 small-font-size">
          Save Preview to:
        </div>
        <div class="cell small-9 padding-left">
          <input type="text" [(ngModel)]="map.previewContext" />
        </div>
      }
    </div>
    @for (related of map.relatedEntities; track related) {
      <div class="grid-x">
        <div class="cell small-8 checkbox  small-font-size padding-left">
          <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" [attr.id]="related.mapId" [(ngModel)]="related.saveEntity" (ngModelChange)="mapSaveChanged(related.mapId)" />
          <label [attr.for]="related.mapId">
            <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
            {{ getMapName(related.mapId) }} - Creates Entity of type {{ getMapEntity(related.mapId) }} related to {{getMapName(related.parentMapId)}} via {{ getRelationalProperty(related.parentMapId, related.mapId)}}
          </label>
        </div>
        <div class="cell small-4 checkbox small-font-size">
          <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" [attr.id]="getPreviewId(related.mapId)" [(ngModel)]="related.isPreview" (ngModelChange)="previewOnlyChanged(related.mapId)" [disabled]="true" />
          <label [attr.for]="getPreviewId(map.mapId)">
            <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
            Preview Only
          </label>
        </div>
        @if (related.isPreview) {
          <div class="cell small-3 padding-left small-font-size">
            Save Preview to:
          </div>
          <div class="cell small-9">
            <input type="text" [(ngModel)]="related.previewContext" />
          </div>
        }
      </div>
    }
  }
}

